const GeneratorFunction = function* generator() {
  yield
}.constructor

export const isGeneratorFunction = a => a instanceof GeneratorFunction
